import { useEffect } from 'react';
import api from '../api/axios';
import { useParams } from 'react-router-dom';

const RedirectView = () => {
  const { id } = useParams();
  useEffect(() => {
    const fetchData = async () => {
      const response = await api.get(`/submissionRecipient/${id}`);
      console.log(response.data.url);
      window.location.href = response.data.url;
    };
    fetchData();
  }, []);

  return (
    <div>
      <h1>Redirecting...</h1>
    </div>
  );
};

export default RedirectView;